import React from "react";
import {
  CheckCircleOutlined,
  FileTextOutlined,
  CreditCardOutlined,
  SafetyCertificateOutlined,
  HistoryOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";

import "./nujobsSuperadminHowtoRenew.scss";

const NuJobsHowToRenew = () => {
const renewalSteps = [
  {
    number: "01",
    icon: <FileTextOutlined />,
    title: "Select Your Plan",
    description:
      "Go to Renew / Buy Plan and select the subscription duration that best suits your hiring requirements.",
  },
  {
    number: "02",
    icon: <CheckCircleOutlined />,
    title: "Review Your Subscription",
    description:
      "Review your selected plan, number of users, job postings, add-ons, billing details, and final payable amount. Click Renew Subscription to submit your renewal request.",
  },
  {
    number: "03",
    icon: <CreditCardOutlined />,
    title: "Make Payment",
    description:
      "NEFT bank transfer instructions will be sent to your registered email address. Complete the payment and email the payment confirmation to the NuJobs support team for verification.",
  },
  {
    number: "04",
    icon: <SafetyCertificateOutlined />,
    title: "Subscription Activation",
    description:
      "Once your payment is verified by the NuJobs team, your subscription will be activated and the new validity period will be updated in your account.",
  },
];

  return (
    <div className="nujobs-renew-help">
      {/* Header */}
      <div className="nujobs-renew-help-header">
        <div className="header-icon">
          <QuestionCircleOutlined />
        </div>

        <div>
          <h2>How to Renew Your Subscription</h2>
          <p>
            Renewing your NuJobs employer subscription is simple. Follow the
            steps below to continue posting and managing your jobs.
          </p>
        </div>
      </div>

      {/* Steps */}
      <div className="renewal-steps">
        {renewalSteps.map((step, index) => (
          <div className="renewal-step-card" key={step.number}>
            <div className="step-top">
              <div className="step-icon">{step.icon}</div>

              <span className="step-number">
                Step {index + 1}
              </span>
            </div>

            <h3>{step.title}</h3>

            <p>{step.description}</p>
          </div>
        ))}
      </div>

      {/* Activation Information */}
      <div className="renewal-info-box">
        <div className="info-icon">
          <SafetyCertificateOutlined />
        </div>

        <div className="info-content">
          <h3>Manual Subscription Activation</h3>

          <p>
            NuJobs subscriptions are currently activated after payment
            verification. Your subscription will not be renewed automatically.
          </p>
        </div>
      </div>

      {/* History */}
      <div className="renewal-history-info">
        <HistoryOutlined />

        <div>
          <h4>Subscription History</h4>
          <p>
            After activation, your renewed subscription and payment details
            will be available under <strong>Subscription History</strong>.
          </p>
        </div>
      </div>

      {/* Support */}
      <div className="renewal-support">
        <div>
          <h3>Need help with your renewal?</h3>
          <p>
            Contact the NuJobs support team if you need assistance with your
            subscription or payment. Email us at <strong>support@nujobs.com</strong>, Mobile/WhatsApp: <strong>+91 9591270077</strong>.
          </p>
        </div>

      </div>
    </div>
  );
};

export default NuJobsHowToRenew;